/**
 * Componente Skip to Content para navegación por teclado
 * Permite a usuarios con lectores de pantalla saltar al contenido principal
 */

export default function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg focus:shadow-lg"
      aria-label="Saltar al contenido principal"
    >
      Saltar al contenido
    </a>
  );
}
